"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("../Error/WidgetError");
const ractive_1 = require("ractive");
/**
 * Ractive renderer wrapper.
 */
class RactiveWrapper {
    /**
     * Constructs the ractive wrapper.
     *
     * @param {RactiveComponentPluginManager} componentPluginManager
     */
    constructor(componentPluginManager) {
        this.componentPluginManager = componentPluginManager;
    }
    /**
     * Creates all component instances.
     *
     * @return {*}
     */
    createComponents() {
        const components = this.componentPluginManager.createAll();
        const ractiveComponents = {};
        components.forEach((component) => {
            const elementName = component.getElementName();
            if (ractiveComponents[elementName]) {
                throw new WidgetError_1.default(`Duplicate ractive component element name: ${elementName}.`);
            }
            ractiveComponents[elementName] = component.getComponent();
        });
        components.forEach((component) => {
            component.getDependentComponents().forEach((dependency) => {
                const dependencyComponent = components.find((comp) => comp.getDefinition().getId() === dependency);
                if (!dependencyComponent) {
                    throw new WidgetError_1.default(`Dependency component '${dependency}' for component '${component.getDefinition().getId()}' not found.`);
                }
                ractiveComponents[component.getElementName()]
                    .components[dependencyComponent.getElementName()] = ractiveComponents[dependencyComponent.getElementName()];
            });
        });
        return ractiveComponents;
    }
    /**
     * Creates a ractive renderer.
     *
     * @param {string} template
     * @param {WidgetConfig} widgetConfig
     * @param {WidgetState} state
     * @return {any}
     */
    createRenderer(template, widgetConfig, state) {
        const renderer = new ractive_1.Ractive({
            components: this.createComponents(),
            target: "#" + widgetConfig.getContainerId(),
            template: template,
            data: Object.assign({}, state.getAll(), { widgetConfig: widgetConfig })
        });
        const callback = (key, value) => {
            if (key === "") {
                const map = {};
                Object.entries(value).forEach(([keyO, valueO]) => {
                    map[keyO] = valueO;
                });
                renderer.set(map);
            }
            else {
                renderer.set(key, value);
            }
        };
        renderer.on("teardown", () => {
            state.removeListener("change", callback);
        });
        state.on("change", callback);
        return renderer;
    }
}
exports.RactiveWrapper = RactiveWrapper;
